module.exports = __webpack_public_path__ + "media/src/images/site-top/icon-ishikawa-sm-b4554f7ad058b8749a4f69a86fabe095.png";